import { createI18n } from 'vue-i18n'
import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           localStorage.getItem('locale') || 'sl',
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],
})

export default i18n

/** Translate outside a component setup scope (stores, libs, enums). */
export const t = (key: string, named?: Record<string, unknown>): string =>
    named ? i18n.global.t(key, named) : i18n.global.t(key)

/**
 * Does this build have a sentence for that key?
 *
 * It exists for the values the **server** names and this SPA renders — a command error code, an
 * apply reason, an issue type (§9.5). A panel one release behind its fleet receives words it has
 * no translation for, and the choice is between showing the raw value and showing an i18n key
 * path to an operator. `t()` alone cannot tell those apart, because a missing key resolves to the
 * key itself.
 */
export const te = (key: string): boolean => i18n.global.te(key)
